import { Box } from '@mui/material'
import { useTranslation } from '../../shared/hooks/useIntractionTranslate'
import { FAQItem, FAQCategory } from '../../types/FAQTypes'
import { INTERAX_COLORS } from '../../constants/colors'
import { stripTranslateMarker } from '../../shared/utils/translationHelpers'

interface FAQInfoBoxProps {
  faq: FAQItem
}

export default function FAQInfoBox({ faq }: FAQInfoBoxProps) {
  const { t } = useTranslation()

  const getCategoryLabel = (category: FAQCategory): string => {
    return stripTranslateMarker(t(`faq.categories.${category}`))
  }

  // Get translated question and description, and strip the $PLEASE_TRANSLATE$ marker
  const question = stripTranslateMarker(t(faq.questionKey))
  const description = stripTranslateMarker(t(faq.descriptionKey))

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        borderRadius: '8px',
        p: 3,
        backgroundColor: INTERAX_COLORS.heritageBlue40
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
        {/* Question Title */}
        <Box
          component="h3"
          sx={{
            fontFamily: 'Lexend Deca, sans-serif',
            fontWeight: 600,
            fontSize: '18px',
            lineHeight: '28px',
            color: INTERAX_COLORS.white,
            m: 0
          }}
        >
          {question}
        </Box>
        {/* Category Tags - Show all categories */}
        {faq.categories.length > 0 && (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>
            {faq.categories.map((category) => (
              <Box
                key={category}
                component="span"
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  textAlign: 'center',
                  px: 1.5,
                  py: 0.5,
                  borderRadius: '9999px',
                  fontFamily: 'Lexend Deca, sans-serif',
                  fontWeight: 500,
                  fontSize: '12px',
                  lineHeight: '16px',
                  color: INTERAX_COLORS.thunderGrey,
                  backgroundColor: INTERAX_COLORS.thunderGrey20
                }}
              >
                {getCategoryLabel(category)}
              </Box>
            ))}
          </Box>
        )}
      </Box>
      {/* Description */}
      <Box
        component="p"
        sx={{
          fontFamily: 'Lexend Deca, sans-serif',
          fontWeight: 400,
          fontSize: '14px',
          lineHeight: '20px',
          color: INTERAX_COLORS.thunderGrey,
          m: 0
        }}
      >
        {description}
      </Box>
    </Box>
  )
}
